import { actionTooltipProps } from "@/ds";

/** Valor sem dado (Figma 5651:228915: hífen). */
export const OBRA_CARD_SEM_VALOR = "-";

export const OBRA_CARD_REALIZADO_LABEL = "Realizado";

/**
 * Métricas do card (esteira 713:28518): sigla no rótulo e o nome completo na tooltip (Figma 5632:80427 a 5632:80568). CO é
 * "Cotado" (comentário de 14/10 na HU 2670, que vale também para o Painel de Obras); a chave `comprometido` vem do contrato.
 */
export const OBRA_CARD_METRICAS = [
  { key: "empenhado", sigla: "EM", nome: "Empenhado" },
  { key: "comprometido", sigla: "CO", nome: "Cotado" },
  { key: "estimado", sigla: "ES", nome: "Estimado" },
  { key: "naoComprometido", sigla: "NC", nome: "Não Comprometido" },
] as const;

/**
 * Abaixo deste percentual o rótulo da barra (12px a 7 da esquerda, ~35px dos 224) fica fora do preenchimento e passa a
 * surface/400, como o 0% do Figma (progress-bar-realizado 713:28591).
 */
export const OBRA_CARD_ROTULO_FORA_ATE = 16;

/**
 * Posição da tooltip por alvo, lida do `data-pr-position` do alvo: a da barra "% Realizado" e a do ícone de condição ficam
 * acima, com a seta embaixo (Figma 12884:814227 e 12884:814376); só as siglas EM/CO/ES/NC ficam à direita (5632:80427).
 */
export const OBRA_CARD_TOOLTIP_POSITIONS = {
  barra: "top",
  condicao: "top",
  metrica: "right",
} as const;

/** Tooltip do card; o texto vem do `data-pr-tooltip` de cada alvo e a posição, do `data-pr-position` (acima por padrão). */
const { content: _content, ...tooltipProps } = actionTooltipProps("");

export const OBRA_CARD_TOOLTIP_PROPS = tooltipProps;
